'use client';

import { useEffect } from 'react';
import { tracker } from '@/utility/tracking/tracker';
import { PdpTag } from '../actions/fetchTags';

export const RelatedTagsTracker = ({ tags }: { tags: PdpTag[] }) => {
  useEffect(() => {
    // React runs effects bottom-up, so this gets overwritten by PageTracker on page navigation. Use setTimeout to push this effect to macrotask queue, so it runs after PageTracker
    const id = setTimeout(() => {
      const relatedTags = tags.map((tag) => tag.name);
      tracker.trackClientProduct({ product: { relatedTags } });
    }, 0);
    return () => clearTimeout(id);
  }, [tags]);

  return null;
};
